export class DataCatalogGlueProperties {
    'region';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogGlueProperties.attributeTypeMap;
    }
    constructor() {
    }
}
